import { render, staticRenderFns } from "./EcografiaAddominaleView.vue?vue&type=template&id=0fbc9560"
import script from "./EcografiaAddominaleView.vue?vue&type=script&lang=js"
export * from "./EcografiaAddominaleView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports